import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, concatMap, map, mergeMap, switchMap, withLatestFrom } from "rxjs/operators";

import { CommonActions } from "../actions/common.actions";
import { Store } from "@ngrx/store";
import { Appointment } from "src/app/public/common/models/appointment.model";
import { Conversation } from "src/app/public/common/models/conversation.model";
import { CommonService } from "src/app/public/common/services/common.service";

@Injectable()
export class CommonApiEffects{

    constructor(
        private commonService: CommonService,
        private actions$: Actions,
        private store: Store
    ){}
    
    addNewAppointment$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CommonActions.appointmentNewSubmit),
            concatMap( (action) => {
                return this.commonService
                    .addNewAppointment (action.appointment)
                    .pipe( 
                        map( (result: Appointment) => { 
                            //if(carCriteria !== null)
                                return CommonActions.appointmentUpsertSuccess ( { appointment: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    updateAppointment$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CommonActions.appointmentUpdateSubmit),
            concatMap( (action) => {
                return this.commonService
                    .updateAppointment (action.appointment)
                    .pipe( 
                        map( (result: Appointment) => { 
                            
                                return CommonActions.appointmentUpsertSuccess ( { appointment: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    updateAppointmentStatus$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CommonActions.appointmentStatusUpdateSubmit),
            concatMap( (action) => {
                return this.commonService
                    .updateAppointmentStatus (action.appointmentId, action.status)
                    .pipe( 
                        map( (result: Appointment) => { 
                            
                                return CommonActions.appointmentUpsertSuccess ( { appointment: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    rescheduleAppointment$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CommonActions.appointmentRescheduleSubmit),
            concatMap( (action) => {
                return this.commonService
                    .rescheduleAppointment (action.appointmentId, action.rescDate)
                    .pipe( 
                        map( (result: Appointment) => { 
                            
                                return CommonActions.appointmentUpsertSuccess( { appointment: result, objectSource: action.objectSource } );
                            })
                        )
            })
        )
    });

    fetchMyAppointments$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CommonActions.fetchMyAppointmentsSubmit),
            concatMap( () => {
                return this.commonService
                    .fetchMyAppointments ()
                    .pipe( 
                        map( (appointments: Appointment[]) => { 
                            //if(carCriteria !== null)
                                return CommonActions.fetchMyAppointmentsSuccess ( {appointments: appointments} );
                            })
                        )
            })
        )
    });


    // Conversations

    fetchMyConversations$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(CommonActions.fetchMyConversationsSubmit),
            concatMap( () => {
                return this.commonService
                    .fetchMyConversations ()
                    .pipe( 
                        map( (conversations: Conversation[]) => { 
                            //if(carCriteria !== null)
                                return CommonActions.fetchMyConversationsSuccess ( {conversations: conversations} );
                            })
                        )
            })
        )
    });



}